module.exports = __webpack_public_path__ + "img/button.b15a570d.png";